import { render, staticRenderFns } from "./VMValidator.vue?vue&type=template&id=2b093c8d&lang=pug&"
import script from "./VMValidator.vue?vue&type=script&lang=js&"
export * from "./VMValidator.vue?vue&type=script&lang=js&"
import style0 from "./VMValidator.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports